<template>
  <el-drawer
    :title="title"
    :append-to-body="appendToBoddy"
    :visible.sync="drawer"
    :with-header="true"
    size="70%"
    :before-close="handleOpenDrawer"
  >
    <el-container>
      <el-main>
        <el-row>
          <el-col>
            <el-form
              :model="dataHeader"
              label-position="left"
              size="mini"
              label-width="120px"
            >
              <el-row>
                <el-col>
                  <rabbey-table-3
                    ref="table"
                    v-loading="loading"
                    :columns="columns"
                    :data="items"
                  />
                </el-col>
              </el-row>
            </el-form>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </el-drawer>
</template>

<script>
import { formatMonto, formatDate } from "@/utils";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "ClientWithoutCallingDetails",
  props: {
    appendToBoddy: {
      type: Boolean,
      default: true,
      required: false
    }
  },
  data() {
    return {
      activeColapseName: ["1"],
      personType: "",
      Option: "",
      contractNo: "",
      clientName: "",
      month: 0,
      title: "Datos de los clientes sin Visitar",
      drawer: false,
      cantidad: 0,
      PersonName: "",
      loading: false,
      items: [],
      contracsCancells: [],
      dataHeader: [],
      columns: [
        {
          prop: "user_id",
          label: "ID de usuario",
          minWidth: 100
        },
        {
          prop: "model_name",
          label: "Modelo",
          minWidth: 150
        },
        {
          prop: "label",
          label: "Label",
          minWidth: 150
        },
        {
          prop: "clone",
          label: "Clone",
          minWidth: 80
        },
        {
          prop: "creation_date",
          label: "Fecha de registro",
          minWidth: 300
        }
      ]
    };
  },
  computed: {
    ...mapGetters("navixy", ["getReportGpsByCurrentUser"])
  },
  watch: {
    getReportGpsByCurrentUser(data) {
      this.items = data.list;
    }
  },
  methods: {
    ...mapActions("navixy", [
      "request",
      "searchUserId",
      "reportGpsByUser",
      "reportGps12H"
    ]),
    formatMonto,
    formatDate,
    clearData() {
      this.contracsCancells = [];
      this.cantidad = 0;
    },
    show(props) {
      this.clientName = props.row.Nombre;
      this.contractNo = props.row.No_Contrato;
      this.dataHeader = props.row;
      let title = "Equipos en navixy";

      this.title = title;

      this.drawer = true;
      this.loading = true;

      this.getItems(props.row.ClientCode);
    },
    handleOpenDrawer(done) {
      this.clearData();
      done();
    },
    async getItems(client_code) {
      this.scode = client_code;
      this.loading = true;

      try {
        const userId = await this.$store.dispatch("navixy/searchUserId", {
          client_code: client_code
        });

        this.sid = userId;
        if (userId > -1) {
          this.reportGpsByUser({ sid: userId }).finally(() => {
            this.loading = false;
          });
        } else {
          this.loading = false;
          this.$message.error("Error al consultar el id del cliente");
        }
      } catch (error) {
        console.error(error);
        this.$notify.error({
          title: "Error",
          message: "El usuario de este cliente no se ha creado en Navixy"
        });
      }
    }
  }
};
</script>

<style></style>
